import React from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './Keycloak';
import Loading from './views/ui-components/Loading';

const KeycloakProviderWrapper = ({ children }) => {
  return (
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'check-sso',
        checkLoginIframe: true,
        silentCheckSsoRedirectUri: `${window.location.origin}/silent-check-sso.html`,
        pkceMethod: 'S256',
        promiseType: 'native',
      }}
      LoadingComponent={<Loading />}
    >
      {children}
    </ReactKeycloakProvider>
  );
};

export default KeycloakProviderWrapper;
